// Shim: the base API moved to @consolidocs-ui/data-access.
// Not a pure re-export: lib/uppyInstance.ts imports a concrete
// getTokenFromLocalStorage from this module path.
import { createCognitoTokenReader } from '@consolidocs-ui/data-access';

export { enhanceEndpoints, baseApi, API_REDUCER_PATH } from '@consolidocs-ui/data-access';

export const getTokenFromLocalStorage = createCognitoTokenReader(
  import.meta.env.VITE_COGNITO_AUTH_AUTHORITY,
  import.meta.env.VITE_COGNITO_AUTH_CLIENT_ID
);
